import React from "react";
import ViewsLoading from "theme/views/ViewsLoading";
import loadable from "@loadable/component";

const options = {
    fallback: <ViewsLoading />,
};

export default {
    storm_collection: loadable(() => import("./BrandCollection"), options),
    default: loadable(() => import("./Default"), options),
};
